'use client';
import { isNumber } from 'lodash-es';
import Image, { type ImageProps } from 'next/image';
import { useEffect, useRef } from 'react';

import { clc } from '@/legacy/components/base/utils';

import styles from '@/legacy/components/img/Img.module.scss';

type Props = {
	alt?: string;
	setAspect: React.Dispatch<React.SetStateAction<number>>;
};

const AspectFillImage = ({ src, alt, className, style, setAspect, ...props }: Omit<ImageProps, 'alt'> & Props) => {
	const ref = useRef<HTMLImageElement>(null);

	useEffect(() => {
		if (ref.current) {
			const aspect = ref.current.naturalWidth / ref.current.naturalHeight;
			if (isNumber(aspect)) setAspect(ref.current.naturalWidth / ref.current.naturalHeight);
		}
	}, [ref.current]);

	return (
		<Image
			alt={alt ? alt : 'image'}
			className={clc(styles['img'], className)}
			fill
			src={src}
			style={{ objectFit: 'cover', ...style }}
			{...props}
			ref={ref}
		/>
	);
};

export default AspectFillImage;
